module.exports = __webpack_public_path__ + "media/images/mock-thumbs/product-1-1fbee0f55ce56d5553bab2989687d081.png";